<template>
  <div>
    <list
      row-key="TradeUnitId"
      ref="list"
      unit="应收总账"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="getDataFunc"
      :show-summary="summaryShow"
      :summary-method="summaryFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <el-form-item label="查询类型">
          <el-select size="mini" v-model="params.Kind" clearable>
            <el-option label="普通应收" value="普通应收" />
            <el-option label="预收" value="预收" />
            <el-option label="其它应收" value="其它应收" />
          </el-select>
        </el-form-item>
        <el-form-item label="对账周期">
          <el-select size="mini" v-model="params.Cycle" @change="cycleChange" clearable>
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期" v-if="!isMB">
          <range-picker :date="[params.DocDateStart,params.DocDateEnd]" @change="dateChange" />
        </el-form-item>
        <template v-else>
          <el-form-item label="对账日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="对账期间">
          <range-picker month :s-date="sDate" :e-date="eDate" :date="date" @change="monthChange" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TradeUnitName" label="客户名称" min-width="120" />
        <el-table-column prop="PreviousBalance" label="期初余额" />
        <el-table-column prop="CurrentIncome" label="应收">
          <template slot-scope="{row}">
            <el-link type="primary" @click="onClick(row)">{{row.CurrentIncome}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="CurrentPay" label="已收">
          <template slot-scope="{row}">
            <el-link type="primary" @click="onClick(row)">{{row.CurrentPay}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="CurrentBalance" label="期末余额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <list-dialog ref="listDialog" />
    <!-- <customer ref="customer" selectable @select="setTradeunit" /> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import listDialog from "@/components/fund/contactcash/inledgerdts/listDialog";
// import customer from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list, listDialog, customer },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      params: {
        Kind: "", //普通应收、预收，其它应收
        TradeUnitId: null,
        TradeUnitName: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
        MonthStart: null,
        MonthEnd: null,
        Cycle: "",
      },
      isMB: this.$store.state.isMB,
      summaryShow: false,
      total: null
    };
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        if (!params.DocDateStart) params.DocDateStart = params.MonthStart;
        if (!params.DocDateEnd) params.DocDateEnd = params.MonthEnd;

        if (!params.DocDateStart || !params.DocDateEnd) {
          this.$message.warning("请选择对账日期或对账期间");
          resolve({ Data: [] });
        } else {
          this.api.getRpRcvPaySum(params).then((res) =>{
            let times = Math.ceil(res.Count / params.pageSize);
            //判断是否最后一页
            if (times == params.pageIndex) {
              this.api.getRpRcvPaySumTotal(params).then(res => {
                if (res.Code == 0 && res.Data) {
                  this.total = res.Data[0];
                  this.summaryShow = true;
                } else {
                  this.summaryShow = false;
                }
              })
            } else {
              this.summaryShow = false;
            }
            resolve(res)
          });
        }
      });
    },
    openTradeunit() {
      this.$refs.customer.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id;
      this.params.TradeUnitName = data.Name;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportRcvSum(this.params).then(() => {
        loading.close();
      });
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['PreviousBalance','CurrentIncome','CurrentPay','CurrentBalance']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>